import { useState, useEffect } from "react";

const SECTIONS = [
  { id: "pd-overview",   en: "Overview",    ar: "نظرة عامة" },
  { id: "pd-amenities",  en: "Amenities",   ar: "المرافق" },
  { id: "pd-masterplan", en: "Master Plan", ar: "المخطط" },
  { id: "pd-units",      en: "Units",       ar: "الوحدات" },
  { id: "pd-location",   en: "Location",    ar: "الموقع" },
];

export default function ProjectNav({ lang }) {
  const [active, setActive] = useState("pd-overview");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.55);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const observers = SECTIONS.map(({ id }) => {
      const el = document.getElementById(id);
      if (!el) return null;
      const obs = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) setActive(id); },
        { rootMargin: "-35% 0px -55% 0px" }
      );
      obs.observe(el);
      return obs;
    });
    return () => observers.forEach(o => o?.disconnect());
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const offset = 64;
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: "smooth" });
  };

  return (
    <div
      className={`pd-nav${visible ? " pd-nav-visible" : ""}`}
      style={{ opacity: visible ? 1 : 0, pointerEvents: visible ? "auto" : "none" }}
    >
      <div
        style={{
          maxWidth: 1280,
          margin: "0 auto",
          padding: "0 5%",
          display: "flex",
          gap: 0,
        }}
      >
        {SECTIONS.map(({ id, en, ar }) => {
          const isActive = active === id;
          return (
            <button
              key={id}
              onClick={() => scrollTo(id)}
              style={{
                padding: "1.05rem 1.4rem",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontFamily: "var(--sans)",
                fontSize: ".76rem",
                letterSpacing: ".1em",
                textTransform: "uppercase",
                color: isActive ? "var(--gold)" : "var(--gray)",
                borderBottom: isActive ? "2px solid var(--gold)" : "2px solid transparent",
                transition: "all .22s",
                whiteSpace: "nowrap",
                fontWeight: isActive ? 600 : 400,
              }}
            >
              {lang === "ar" ? ar : en}
            </button>
          );
        })}
      </div>
    </div>
  );
}
